export default {
	title: "Templates",
};
